import React from "react";
import { Typography } from "../ecosystem/";

class InEligibilityModalInfo extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="row ineligibility-info-container">
                <div className="col-12 maxWidth-content">
                    <Typography type={"heading-06"}
                        responsive>
                        Not eligible for Video Visit Scheduling
                    </Typography>
                    <div className="ineligibility-subheading">
                        <Typography type={"body-03"}
                            color={"$color-secondary-a1"}
                            responsive
                        >
                            The following reasons cannot be scheduled for a video visit. If you are experiencing something from the list below please schedule for an in-person visit.
                        </Typography>
                    </div>
                    <div className="ineligibility-list">
                        <Typography
                            type="body-03"
                            color="$color-primary-a2"
                            responsive
                            tag="div"
                        >
                            <div>Abdominal Pain</div>
                            <div>Abscesses/Boils</div>
                            <div>Adult and Pediatric Annual Physicals</div>
                            <div>Chest Pain</div>
                            <div>Genital or Urinary Issues*</div>
                            <div>Heart Palpitations (rapid, strong, or irregular heartbeat)</div>
                            <div>Lacerations</div>
                            <div>Pelvic Pain</div>
                        </Typography>
                    </div>
                    <div className="ineligibility-footer">
                        <Typography type={"body-03"}
                            responsive>
                            *Females are eligible for UTI and yeast infections via video visit.
                        </Typography>
                    </div>
                </div>
            </div>
        )
    }
}

export default InEligibilityModalInfo;